/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './GrayPanel.scss';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';

class GrayPanel extends React.Component {
  state = {
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  render() {
    return (
      <div style={{ fontSize: this.props.fontSize + 'rem', clear: 'both'}, this.props.style ? {...this.props.style} :null}>
        <div className="col-xs-12 col-mobile" >
          <div className={this.props.hasError && this.props.hasError === true ? "grayPanel hasError" : "grayPanel"} style={this.state.style}>
            <div className="basePanelHeading" style={this.state.style}>{this.props.title}</div>
            <div className="panel-body grayPanelBody" style={this.props.bodyStyle ? this.props.bodyStyle : null}>
              {this.props.children}
            </div>
          </div>
        </div>
        <div style={{clear: 'both'}} />
      </div>
    );
  }
}

const mapState = (state) => ({
  fontSize: state.runtime.fontSize,
});

export default withStyles(s)(connect(mapState)(GrayPanel));



// WEBPACK FOOTER //
// src/components/GrayPanel/GrayPanel.js